<template>
    <v-dialog eager :modelValue="true" :max-width="width" persistent @keydown.esc="choose(false)">
        <v-card>
            <v-card-text class="text-body-1 text-body-1 py-3" v-html="message"/>
            <v-card-actions>
                <v-btn
                    :color="buttonFalseColor"
                    @click="choose(false)"
                >{{ buttonFalseText }}</v-btn>
                <v-btn
                    :color="buttonTrueColor"
                    @click="choose(true)"
                >{{ buttonTrueText }}</v-btn>
            </v-card-actions>
            <v-spacer/>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        buttonTrueText: {
            type: String,
            default: 'تایید'
        },
        buttonFalseText: {
            type: String,
            default: 'انصراف'
        },
        buttonTrueColor: {
            type: String,
            default: 'secondary'
        },
        buttonFalseColor: {
            type: String,
            default: 'grey-darken-1'
        },
        message: {
            type: String,
            required: true
        },
        width: {
            type: Number,
            default: 450
        }
    },
    methods: {
        onEnterPressed (e) {
            if (e.keyCode === 13) {
                e.stopPropagation()
                this.choose(true)
            }
        },
        choose (value) {
            this.$emit('done', value);
        }
    },
    mounted () {
        document.addEventListener('keyup', this.onEnterPressed)
    },
    unmounted () {
        document.removeEventListener('keyup', this.onEnterPressed)
    },
}
</script>
